module.exports = __webpack_public_path__ + "static/media/token-logo.8265592b.png";